// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Scrollable$Showside from "../components/Scrollable.bs.js";
import * as ReactDOMUtils$Showside from "./ReactDOMUtils.bs.js";
import * as LocationConfig$Showside from "./LocationConfig.bs.js";
import * as ScrollRestoration$Showside from "./ScrollRestoration.bs.js";
import * as ListPageLayoutController$Showside from "../hook/ListPageLayoutController.bs.js";
function ScrollRestorationBreaker(Props) {
  var id = Props.id;
  var adjustTo = Props.adjustTo;
  var paddingOpt = Props.padding;
  var padding = paddingOpt !== undefined ? paddingOpt : 24;
  var ref = React.useRef(null);
  LocationConfig$Showside.use(undefined);
  var scrollableCtx = Scrollable$Showside.useScrollableContext(undefined);
  var match = ListPageLayoutController$Showside.Context.use(undefined);
  var match$1 = match.state;
  var showPrimaryNavbar = match$1.showPrimaryNavbar;
  var secondaryNavbarHeight = match$1.secondaryNavbarHeight;
  var primaryNavbarHeight = match$1.primaryNavbarHeight;
  var adjustToLayout = function (absoluteTop) {
    switch (adjustTo) {
      case /* AdjustToPrimaryNavbar */0:
        if (showPrimaryNavbar) {
          return absoluteTop - primaryNavbarHeight | 0;
        } else {
          return absoluteTop;
        }
      case /* AdjustToSecondaryNavbar */1:
        if (showPrimaryNavbar) {
          return absoluteTop - (primaryNavbarHeight + secondaryNavbarHeight | 0) | 0;
        } else {
          return absoluteTop - secondaryNavbarHeight | 0;
        }
      case /* DoNotAdjust */2:
        return absoluteTop;
    }
  };
  React.useEffect(function () {
    var breakerEl = ref.current;
    var handleScroll = function (e) {
      var el = scrollableCtx.element;
      var scrollTop = el !== undefined ? Caml_option.valFromOption(el).scrollTop : window.scrollY;
      if (breakerEl == null) {
        return;
      }
      var absoluteTop = breakerEl.getBoundingClientRect().top + scrollTop;
      var adjustedAbsoluteTop = adjustToLayout(absoluteTop | 0);
      ScrollRestoration$Showside.setBreakingPoint(padding, id, adjustedAbsoluteTop);
    };
    var el = scrollableCtx.element;
    if (el !== undefined) {
      var el$1 = Caml_option.valFromOption(el);
      el$1.addEventListener("scroll", handleScroll);
      return function (param) {
        el$1.removeEventListener("scroll", handleScroll);
        ScrollRestoration$Showside.removeBreakingPoint(id);
      };
    }
    window.addEventListener("scroll", handleScroll);
    return function (param) {
      window.removeEventListener("scroll", handleScroll);
      ScrollRestoration$Showside.removeBreakingPoint(id);
    };
  }, [scrollableCtx, showPrimaryNavbar]);
  return React.createElement("div", {
    ref: ReactDOMUtils$Showside.Ref.domRef(ref)
  });
}
ScrollRestorationBreaker.displayName = "ScrollRestorationBreaker";
var make = ScrollRestorationBreaker;
export { make };
/* react Not a pure module */